<script>
  /**
   * @typedef {Object} Props
   * @property {number} [size=40] The width and height dimension for the icon
   * @property {string} [fill="#000000"] The color to fill the icon
   */

  /** @type {Props} */
  let { size = 40, fill = "#000000" } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 48 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  role="img"
  aria-label="Left arrow icon"
>
  <path
    d="M35.3565 47.6745C35.1304 47.8972 34.8348 48 34.4696 48C34.1044 48 33.7739 47.8972 33.4783 47.6745L10.4348 24.8737C10.1391 24.651 10 24.3597 10 24C10 23.6403 10.1391 23.349 10.4348 23.1263L33.4783 0.325485C33.7739 0.102787 34.1044 0 34.4696 0C34.8348 0 35.1304 0.102787 35.3565 0.325485L37.5652 2.50107C37.8609 2.70664 38 2.99786 38 3.35761C38 3.71735 37.8609 4.04283 37.5652 4.33405L17.6 24L37.5652 43.6488C37.8609 43.94 38 44.2655 38 44.6253C38 44.985 37.8609 45.2762 37.5652 45.4989L35.3565 47.6745Z"
    {fill}
  />
</svg>
